<template>
  <div class="chatGptStat-container">
    <div class="chatGptStat-card">
      <div class="chatGptStat-barChart-header">
        <div class="font-format-big">{{ gptData.name }}</div>
        <!-- <div>查看详情</div> -->
      </div>
      <div class="chatGptStat-main">
        <div class="chatGptStat-useInfo">
          <div class="chatGptStat-useInfo-item">
            <div class="chatGptStat-useInfo-item-title">
              {{ gptData.text }}：
            </div>
            <div class="chatGptStat-useInfo-item-value">
              {{ gptData.total ? filterSize(gptData.total) : 0 }}
            </div>
          </div>
        </div>
        <div class="chatGptStat-barChart" ref="chatGptStatMain">
          <div ref="barChart" style="width: 100%;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  props: {
    gptData: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  computed: {},
  data() {
    return {
      myChart: null,
      params: {
        dateType: 'day',
        model: '',
        endTime: ''
      },
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: []
        },
        grid: {
          left: '10%',
          right: '5%'
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            axisLabel: { show: true, interval: 0, rotate: 45 },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: []
      }
    }
  },
  methods: {
    async initChart() {
      this.myChart ? this.myChart.clear() : ''
      this.myChart = echarts.init(this.$refs.barChart)
      this.options.xAxis[0].data = this.gptData.date
      this.options.series = await this.getSeriesData()
      if (this.gptData.key === 'size') {
        this.options.yAxis[0].name = '单位：MB'
        this.options.tooltip.formatter = this.tooltip
      } else if (this.gptData.key === 'count') {
        this.options.yAxis[0].name = '单位：次'
      }

      this.myChart.setOption(this.options)
    },

    async renderSize(data) {
      try {
        let tmp = []
        for (let item of data) {
          tmp = [...tmp, (item / Math.pow(1024, 2)).toFixed(2)]
        }
        return tmp
      } catch (error) {}
    },

    tooltip(params) {
      let children = ''
      for (let item of params) {
        children += `<p>${item.seriesName}：${item.data}MB</p>`
      }
      let document = `
        <div>
          <p>${params[0].name}</p>
          ${children}
        </div>
      `
      return document
    },

    async getSeriesData() {
      try {
        let seriesData = []
        let tmpData = []
        if (this.gptData.key === 'size') {
          tmpData = await this.renderSize(this.gptData.data)
        } else {
          tmpData = this.gptData.data
        }
        seriesData.push({
          name: this.gptData.text,
          type: 'bar',
          barGap: 0,
          label: {
            show: false,
            rotate: 90,
            align: 'left',
            verticalAlign: 'middle',
            position: 'insideBottom',
            formatter: '{a} : {c}',
            fontSize: 14
            // rich: {
            //   name: {
            //     fontSize: 16,
            //     color: '#000'
            //   }
            // }
          },
          emphasis: {
            focus: 'series'
          },
          data: tmpData
        })

        return seriesData
      } catch (error) {}
    },
    filterSize(value) {
      if (value === null || value === '' || !value) {
        return '0 B'
      }
      let unitArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      let index = 0
      let srcsize = parseFloat(value)
      index = Math.floor(Math.log(srcsize) / Math.log(1024))
      var size = srcsize / Math.pow(1024, index)
      //  保留的小数位数
      size = size.toFixed(2)
      return size + unitArr[index]
    },
    chartResize() {
      this.myChart ? this.myChart.resize({ width: 'auto' }) : null
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize)
  },
  mounted() {
    if (this.$refs.barChart) {
      this.$refs.barChart.style.height =
        this.$refs.chatGptStatMain.clientHeight + 'px'
    }
    this.initChart()
    window.addEventListener('resize', this.chartResize)
  }
}
</script>

<style lang="scss" scoped>
.chatGptStat-container {
  flex: 1;
  display: flex;
  overflow: hidden;
  > .chatGptStat-card {
    flex: 1;
    /* height: 420px; */
    display: flex;
    flex-direction: column;
    padding: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    background: #fff;
    box-sizing: border-box;
    border-radius: 4px;
    .chatGptStat-barChart-header {
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .chatGptStat-main {
      display: flex;
      flex: 1;
      flex-direction: column;
      /* align-items: center; */
      .chatGptStat-useInfo {
        padding: 20px;
        box-sizing: border-box;
        background: #f9f9f9;
        border-radius: 10px;
        .chatGptStat-useInfo-item {
          /* display: flex;
        justify-content: space-between; */
          align-items: center;
          margin-bottom: 6px;
          .chatGptStat-useInfo-item-name {
            font-size: 14px;
            color: #888888;
          }
          .chatGptStat-useInfo-item-value {
            font-size: 24px;
            color: #c90d0d;
          }
        }
      }
      .chatGptStat-barChart {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
      }
    }
  }
}
</style>
